import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { apiService } from '../../constants/ApiService';

const RewardCardStatsModal = (props) => {

    const authData = useSelector(state => state.authState);
    const [userDetail, setUserDetail] = useState(authData.user);

    const [rewardCardList, setRewardCardList] = useState([]);

    useEffect(() => {

        if (authData.login) {
            getRewardCardList()
        }
    }, [])

    const getRewardCardList = async () => {

        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/TreeTesting/GetUserRewadCards?userMob=${userDetail.user_mobile}`, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            console.log(response)

            if (response.status === true) {
                setRewardCardList(response.rewardCardDataList);
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }

    return (
        <>
            <div
                className="modal fade theme-modal show"
                id="add-address"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-modal="true"
                role="dialog"
                style={{ display: "block", paddingLeft: 0 }}
            >
                {/* // Add a new address */}

                <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
                    <div className="modal-content shadow-lg">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Points Contributors <i className="fa fa-info-circle"></i>
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => { props.handleRewardCardStatsClose() }}
                            // data-bs-dismiss="modal"
                            // aria-label="Close"
                            >
                                <i className="fa-solid fa-xmark" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Level reached</th>
                                        <th scope="col">Reward Card no.</th>
                                        {/* <th scope="col">Coins required for next level</th> */}
                                        {/* <th scope="col">Order Id</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rewardCardList.map((item, index) => {
                                        return (
                                            <>
                                                <tr>
                                                    <th scope="row">{index + 1}</th>
                                                    <td>Level {item.level_no}</td>
                                                    <td>{item.reward_card_no}</td>
                                                </tr>
                                            </>)
                                    })}

                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">

                            <button
                                type="button"
                                className="btn theme-bg-color btn-md text-white"
                                // data-bs-dismiss="modal"
                                onClick={() => { props.handleRewardCardStatsClose() }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default RewardCardStatsModal;